import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Supabase bağlantısı — hesap ve istatistikler için.
 *
 * Yapılandırma YOKSA `null` dönüyor ve oyun çalışmaya devam ediyor: botlara
 * karşı oynamak hesap gerektirmiyor, giriş ekranı da hesapsız moda düşüyor.
 * Bu bilinçli — anahtarı olmayan bir geliştirme kopyasında oyunun tamamen
 * açılmaması saçma olurdu.
 */

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase: SupabaseClient | null =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          // PWA tek sayfa; URL'de oturum parçası taşımıyoruz.
          detectSessionInUrl: false,
        },
      })
    : null;

export const hasAccounts = supabase !== null;

/**
 * Kullanıcı adını Supabase'in beklediği e-posta biçimine çevirir.
 *
 * Supabase Auth e-posta/şifre ile çalışıyor, oysa oyuncular kullanıcı adıyla
 * giriyor. Ad, gerçek posta kutusu olmayan sabit bir alan adına eşleniyor;
 * oyuncu e-posta diye bir şey görmüyor, doğrulama postası da gönderilmiyor
 * (projede otomatik onay açık).
 */
export const emailForUsername = (username: string): string =>
  `${username.trim().toLowerCase()}@basgan.local`;

/** Profil tablosundaki kısıtın aynısı — hata sunucuya gitmeden yakalansın. */
export const USERNAME_RULE = /^[a-z0-9_]{3,20}$/;
